module.exports = __webpack_public_path__ + "media/images/emblems/Hittnau-blazon-26d751352373529a0ee172990b7e5a44.svg";